export default __webpack_public_path__ + "static/spelinspektionen-granskar-casinon-i-sverige-03b79b2abc2c1b6c043a6799c8f9bf1b.jpg";